import { ReactNode } from 'react'
import { AccountIconEditable } from '../account-icon'
import { ScanExplorerButton } from '../common/account-profile-form/scan-explorer'

import { useStyles } from './styles'

interface IProps {
  arweaveUri: string | null
  isAccountOwner: boolean
  isMinting: boolean
  tokenId: string | null
  locale?: string
  additionalItem?: ReactNode
  aiGenerated: boolean
}

export const MobileIcon = ({
  arweaveUri,
  isAccountOwner,
  isMinting,
  tokenId,
  locale,
  additionalItem,
  aiGenerated,
}: IProps) => {
  const classes = useStyles()

  return (
    <div className={classes.mobileIconWrapper}>
      <AccountIconEditable />
      {!aiGenerated && (
        <ScanExplorerButton
          locale={locale}
          arweaveUri={arweaveUri}
          isAccountOwner={isAccountOwner}
          isMinting={isMinting}
          tokenId={tokenId}
          notShowNftButton
        />
      )}

      {!!additionalItem && additionalItem}
    </div>
  )
}
